import { get } from 'lodash'
import { axios } from '../../../plugins/axios'
import DateAdapter from '../../../utils/DateAdapter'
import { API_DATE_FORMAT } from '@/const'
import BajaLoc from '@/modules/armeria/application/BajaLoc.usecase'
import ArmeriaApiRepository from '@/modules/armeria/infrastructure/ArmeriaApiRepository'

const armeriaRepository = new ArmeriaApiRepository()

export default {
  namespaced: true,

  state: {
    locs: [],
    loc: null,
    selectedLoc: null,
  },

  getters: {
    getLocs: (state) => {
      return state.locs
    },

    getLocToUpdate: (state) => {
      return state.loc
    },
    getSelectedLoc: (state) => {
      return state.selectedLoc
    },
  },

  mutations: {
    SET_LOCS(state, locs) {
      state.locs = locs
    },
    SET_SELECTED_LOC(state, loc) {
      state.selectedLoc = { ...loc }
    },

    SET_LOC_TO_UPDATE(state, idPersonal) {
      var preaspiranteParaValidacion = state.locs.filter((preaspirante) => {
        return preaspirante.id == idPersonal
      })

      var preaspirante = _.cloneDeep(preaspiranteParaValidacion[0])

      state.loc = preaspirante
    },
  },

  actions: {
    fetchLocs: async function ({ commit }) {
      await axios
        .get('/PoliciaCuadrantes/Armeria/loc')
        .then((response) => {
          commit('SET_LOCS', response.data.data)
        })
        .catch((error) => console.log(error))
    },

    saveLoc: async function (context, loc) {
      try {
        await axios.post('/PoliciaCuadrantes/Armeria/loc/', loc.loc).then((response) => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Licencia Oficial Colectiva registrada correctamente.', { root: true })
        })
      } catch (error) {
        console.log(error)
      }
    },
    editLoc: async function ({ commit, dispatch }, loc) {
      try {
        await axios.put('/PoliciaCuadrantes/Armeria/loc/' + loc.idLoc, loc)
        await dispatch('fetchLocs')
        commit('SET_SNACKBAR_MESSAGE', 'Licencia Oficial Colectiva actualizada correctamente.', { root: true })
      } catch (error) {
        console.log(error)
        throw error
      }
    },

    updateLoc: async function ({ commit }, loc) {
      try {
        await axios.put('/PoliciaCuadrantes/Armeria/personal/' + loc.idPersonal + '/loc/', loc)
      } catch (error) {
        console.log(error)
      }
    },

    bajaLoc: async function ({ commit, dispatch }, { idLoc, formData }) {
      try {
        const useCase = new BajaLoc(armeriaRepository)
        await useCase.execute(idLoc, formData)
        await dispatch('fetchLocs')
        commit('SET_SNACKBAR_MESSAGE', 'Baja de LOC registrada correctamente.', { root: true })
      } catch (error) {
        console.log(error)
        throw error
      }
    },

    saveArmaLoc: async function ({ commit }, armaLoc) {
      await axios
        .post('/PoliciaCuadrantes/Armeria/armas/' + armaLoc.arma + '/armasLoc/', {
          fk_idLoc: armaLoc.loc,
        })
        .then((response) => console.log(response))
        .catch((error) => console.log(error))
    },
  },
}
